import React, {useEffect, useState, useRef, useCallback} from "react";
import {createUseStyles, useTheme} from "react-jss";
import TabNavContent from "../../../../../../artibulles-cis/TabNavContent/TabNavContent";
import Table from "../../../../../../artibulles-cis/TableNew/Table.js";
import CardModal from "@artibulles-cis/react/CardModal";
import {isValid, format, parseISO} from "date-fns";
import {PDF} from "@artibulles-cis/react-icons";
import AccountingTransactionEntryEdit from "./AccountingTransactionEntryEdit";

//eslint-disable-next-line
const styles = createUseStyles((theme) => ({
    OverviewWrapper: {
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
    },
    TableWrapper: {
        flex: "1 1 auto",
        width: "100%",
        maxWidth: "100%",
        // height: "100%",
        padding: "10px 0px 0px 0px",
        position: "relative",
        boxSizing: "border-box",
        display: "flex",
        margin: "0 auto",
        justifyContent: "center",
    },
}));

const AccoutingAllTransactionsTable = React.memo(function AccoutingAllTransactionsTable(props) {
    //eslint-disable-next-line
    const theme = useTheme();
    //eslint-disable-next-line
    const classes = styles({...props, theme});

    /***************** REFS ******************/
    const Ref_TabNavContent = useRef(null);
    /***************** REFS ******************/

    /***************** CONST ******************/
    const DevMode = process.env.NODE_ENV === "development" ? true : false;
    const ProdURL = DevMode ? "" : "https://artibulles-bms.artibulles.com";

    const HandleViewPdf = (arg) => {
        console.log("pdf", arg);
        window.open(arg);
    };
    const ColomnsInput = [
        {
            width: "100px",
            caption: "Date",
            cellFormatFunction: (value) => {
                let dateFromIso = parseISO(value);
                if (isValid(dateFromIso)) {
                    return format(parseISO(value), "dd-MMM-yyyy");
                } else {
                    return value;
                }
            },
            datafield: "transaction_date_Iso",
            searchable: true,
            datatype: "date",
            sortable: true,
            initialSort: {order: 1, sortDirection: "Dsc"},
        },
        {width: "80px", caption: "Month", datafield: "calc_transaction_date_MMM", sortable: true, searchable: true, datatype: "text", wrapCell: true},
        {width: "80px", caption: "Year", datafield: "calc_transaction_date_yyyy", sortable: true, searchable: true, datatype: "text", wrapCell: true},

        {
            width: "100px",
            caption: "Amount",
            datafield: "banking_amount_transaction",
            cellCustomRender: (value) => {
                if (value) {
                    let formattedOutput = new Intl.NumberFormat("de-DE", {style: "currency", currency: "EUR", maximumFractionDigits: 2}).format(value);
                    if (value < 0) {
                        return <div style={{color: "red"}}>{formattedOutput}</div>;
                    } else {
                        return formattedOutput;
                    }
                }
            },

            fixedCol: false,
            searchable: true,
            datatype: "number",
            sortable: true,
        },
        {width: "200px", caption: "Customer", datafield: "customer_name", searchable: true, datatype: "text", wrapCell: true},
        {width: "400px", caption: "Accounting communciation", datafield: "accouting_communication", searchable: true, datatype: "text", wrapCell: true},

        {
            width: "130px",
            caption: "Justification provided",
            datafield: "accounting_Justification_Provided_Date",
            cellFormatFunction: (value) => {
                let dateFromIso = parseISO(value);
                if (isValid(dateFromIso)) {
                    return format(parseISO(value), "dd-MMM-yyyy");
                } else {
                    return value;
                }
            },
            searchable: true,
            sortable: true,
            datatype: "date",
            wrapCell: true,
            wrapColHeader: true,
        },
        {
            width: "130px",
            caption: "Justifications",
            datafield: "accounting_Justification_File_Path",
            cellCustomRender: (value) => {
                if (value && Array.isArray(value) && value.length > 0) {
                    let CellRenderComp = [];
                    value.forEach((elem) => {
                        let IconElem = (
                            <div onClick={() => HandleViewPdf(elem.serverPath)}>
                                <PDF SVGFillColor="white" />
                            </div>
                        );
                        CellRenderComp.push(IconElem);
                    });

                    return CellRenderComp;
                } else {
                    return null;
                }
            },

            fixedCol: false,
            searchable: true,
            datatype: "text",
            sortable: true,
        },

        {width: "400px", caption: "communication", datafield: "communication", searchable: true, datatype: "text", wrapCell: true},

        {width: "100px", caption: "Source", datafield: "transaction_source", fixedCol: false, searchable: true, sortable: true, datatype: "text"},
        {
            width: "150px",
            caption: "Account number",
            datafield: "myCompany_bankAccount_number",

            fixedCol: false,
            searchable: true,
            datatype: "number",
            sortable: true,
            wrapColHeader: true,
        },
        {
            width: "150px",
            caption: "Credit card number",
            datafield: "credit_card_number",

            fixedCol: false,
            searchable: true,
            datatype: "number",
            sortable: true,
            wrapColHeader: true,
        },

        {
            width: "100px",
            caption: "Oringal Amount",
            datafield: "original_amount_transaction",
            cellFormatFunction: (value, rowData) => {
                let CellValue = value;
                let AmountValue = rowData.banking_amount_transaction;
                if (CellValue === AmountValue) {
                    return null;
                } else {
                    return new Intl.NumberFormat("de-DE", {style: "currency", currency: "EUR", maximumFractionDigits: 2}).format(value);
                }
            },
            fixedCol: false,
            searchable: true,
            datatype: "number",
            sortable: true,
            wrapColHeader: true,
        },
    ];

    const TableDimensions = {
        width: "800px",
        height: "400px",
        FitContent: false,
        FitParentContainer: true,
    };
    const TotalRow = {
        Show: false,
    };

    const HandleEditRow = (arg) => {
        console.log("arg", arg);
        if (arg) {
            let id = arg._id;

            setShowViewCard(true);
            setViewCardId(id);
        }
    };

    const TableOptions = {
        PagerOptions: {
            InfiniteScroll: false,
            ShowPager: false,
            DefaultPageSize: 30,
            AllowedPageSizes: [15, 30, 45],
        },
        Searchable: true,
        Selectable: false,
        RowButtons: [
            {
                Standard: true,
                Name: "Edit",
                ActiveCondition: null,
                Position: 1,
                OnClick: HandleEditRow,
                IconSize: "10px",
                ActiveColor: "red",
                HoverColor: "green",
                InactiveColor: "blue",
            },
        ],
    };

    const FinalAPIUrlRelative = {
        MAIN: `${ProdURL}/api/companyaccount/transactions/?vatCheck=true`,
        DELETE: "",
        PUT: "",
        POST: "",
    };
    /***************** CONST ******************/

    /***************** STATE ******************/
    const [IsInitalized, setIsInitalized] = useState(true);
    const [ShowViewCard, setShowViewCard] = useState(false);
    const [ViewCardId, setViewCardId] = useState(null);
    const [TableComponent, setTableComponent] = useState(null);
    /***************** STATE ******************/

    /***************** CALLBACK ******************/
    const GenerateTableComponent = useCallback(() => {
        let FinalTableComponent = (
            <Table
                // LocalData={TableData}
                URLRelative={FinalAPIUrlRelative}
                // URLRelative="arnaud"
                MainDataSource="Transactions"
                ColomnsInput={ColomnsInput}
                TableDimensions={TableDimensions}
                TableOptions={TableOptions}
                TotalRow={TotalRow}
                DevMode={false}
            />
        );
        setTableComponent(FinalTableComponent);
    }, []);
    /***************** CALLBACK ******************/

    /***************** EFFECTS ******************/
    useEffect(() => {
        GenerateTableComponent();
    }, [GenerateTableComponent]);

    /***************** EFFECTS ******************/

    /***************** FUNCTIONS ******************/
    const HandleCloseViewCard = () => {
        setShowViewCard(false);
        setViewCardId(null);
    };
    /***************** FUNCTIONS ******************/

    /***************** RENDER ******************/
    var ModalCardView;
    if (ShowViewCard === true) {
        ModalCardView = (
            <CardModal
                // CardID="HealFit_CreateDailyIntake"
                // ParentCompRef={Ref_TabNavContent}
                // TopBarContent={CardTitle}
                CloseCard={HandleCloseViewCard}
                CloseOnClickOutside={true}
                WithCloseButton={true}
                // CardMaxWidth="800px"
                // CardHeight="700px"
                CardWindowPaddingVertical="10px"
                CardWindowPaddingHorizontal="10px"
                WithPerfectScrollbar={true}
                // CardWindowPaddingVertical="50px"

                ShowCard={true}
                WindowBackgroundColor="rgba(0,0,0,0.3)"
                CardBackgroundColor="white"
                CardBackground="white"
                ClassExtendCard={classes.ClassExtendCard}
            >
                <div className={classes.CardContent}>
                    <AccountingTransactionEntryEdit Id={ViewCardId} HandleCloseViewCard={HandleCloseViewCard} />
                </div>
            </CardModal>
        );
    }

    return (
        <TabNavContent
            TabRef={Ref_TabNavContent}
            ClassExtendTabContent={classes.ClassExtendTabContent}
            //   Border={ContentBorder}
            // Background="blue"
            //   InnerPadding={ContentPadding}
            //   MaxWidth={ContentMaxWidth}
            Height="100%"
            // PerfectScrollBar={{Active: true, ScrollX: false, ScrollY: true}}
            // ScrollX="hidden"
            // ScrollY="auto"
        >
            {ModalCardView}
            {TableComponent}
        </TabNavContent>
    );

    /***************** RENDER ******************/
});

export default AccoutingAllTransactionsTable;
